// ng build --configuration production

import { commonEnv } from './environment.common';

const env: Partial<typeof commonEnv> = {
  production: true,
  name: 'production',
  apiEndpoint: 'https://api-prod.timtravel.app/api/',
};

// Export all settings of common replaced by dev options
export const environment = { ...commonEnv, ...env };

// export const environment = {
//   production: true,
//   name: 'production',
//   apiEndpoint: 'https://dash.timtravel.app/api/',
//   googleMapsAPIKey: 'AIzaSyDrwC5HM6VQNKUzsyTFkxtBpVCtBn3csvA',
//   rollbarAccessToken: '95867e41c9434f0a8b382f3a554c3b66',
// };
